<app-spinner></app-spinner>

@if(updateRequired) {
<div class="version-update-overlay">
  <div class="version-update-card">
    <h2>Update Required</h2>
    <p>A new version of the app is available. Please refresh your browser to continue.</p>
    <button mat-raised-button color="primary" (click)="refreshApp()">Refresh Now</button>
  </div>
</div>
}

@if(!isClientPortalRoute) {
<mat-toolbar>
  <mat-toolbar-row class="matToolbarRow">

    <table width="100%">
      <tr>
        <td class="miExactLogoCell">
          <img src="../assets/images/miexact-logo_inverse_white2.png" class="miExactLogo" /><span class="apptitle">Charity Central</span><span class="applegend">A MiExact Product</span>
        </td>
      </tr>
    </table>

    <!--<span><img src="../assets/images/miexact-logo_inverse_white.png" class="miExactLogo"  /> </span><span class="apptitle">Mortality Central</span><span class="applegend">A MiExact Product</span>-->
  </mat-toolbar-row>

  @if(hasLoggedInUser)
  {
  <mat-toolbar-row class="matToolbarRow">
    <div class="flexMenu" [hidden]="!hasLoggedInUser">
      <button mat-flat-button class="flexMenuButton" extended (click)="navigateToScreen('Home')">Home</button>
      <!-- <button mat-flat-button class="flexMenuButton" extended (click)="navigateToScreen('Reading')">Reading</button> -->
      <!-- <button mat-flat-button class="flexMenuButton" extended (click)="navigateToScreen('Reporting')">Reporting</button> -->
      <button mat-flat-button class="flexMenuButton" extended (click)="navigateToScreen('ProbateList')">Probate List</button>
      <button mat-flat-button class="flexMenuButton" extended (click)="navigateToScreen('Feedback')">Feedback</button>
      @if(isSupervisor() || isSystemAdministrator()) {
      <div class="finance-dropdown-wrapper">
        <div class="admin-dropdown-backdrop" *ngIf="isReportsMenuOpen" (click)="isReportsMenuOpen = false"></div>
        <button mat-flat-button class="flexMenuButton" extended (click)="isReportsMenuOpen = !isReportsMenuOpen">Reports</button>
        <div class="finance-dropdown-menu" *ngIf="isReportsMenuOpen">
          <button class="admin-dropdown-item" (click)="navigateToScreen('HmrcWills'); isReportsMenuOpen = false">HMRC Wills</button>
          <button class="admin-dropdown-item" (click)="navigateToScreen('ProbateStatusReport'); isReportsMenuOpen = false">Probate Status</button>
          <button class="admin-dropdown-item" (click)="navigateToScreen('Productivity'); isReportsMenuOpen = false">Productivity</button>
        </div>
      </div>
      }
      <!-- <button mat-flat-button class="flexMenuButton" extended (click)="navigateToScreen('CharityDatabase')">Charity Database</button> -->
      <!-- <button mat-flat-button class="flexMenuButton" extended (click)="navigateToScreen('PAFMatching')">PAF Matching</button> -->
      @if(isSupervisor()) {
      <div class="finance-dropdown-wrapper">
        <div class="admin-dropdown-backdrop" *ngIf="isSupervisorMenuOpen" (click)="isSupervisorMenuOpen = false"></div>
        <button mat-flat-button class="flexMenuButton" extended (click)="isSupervisorMenuOpen = !isSupervisorMenuOpen">Supervisor</button>
        <div class="finance-dropdown-menu" *ngIf="isSupervisorMenuOpen">
          <button class="admin-dropdown-item" (click)="navigateToScreen('Allocation'); isSupervisorMenuOpen = false">Allocation</button>
        </div>
      </div>
      }

      @if(isFinance()) {
      <div class="finance-dropdown-wrapper">
        <div class="admin-dropdown-backdrop" *ngIf="isFinanceMenuOpen" (click)="isFinanceMenuOpen = false"></div>
        <button mat-flat-button class="flexMenuButton" extended (click)="isFinanceMenuOpen = !isFinanceMenuOpen">Finance</button>
        <div class="finance-dropdown-menu" *ngIf="isFinanceMenuOpen">
          <button class="admin-dropdown-item" (click)="navigateToScreen('InvoiceReport'); isFinanceMenuOpen = false">Invoice Report</button>
        </div>
      </div>
      }

      @if(isSystemAdministrator()) {
      <div class="admin-dropdown-wrapper">
        <div class="admin-dropdown-backdrop" *ngIf="isPricingMenuOpen" (click)="isPricingMenuOpen = false"></div>
        <button mat-flat-button class="flexMenuButton" extended (click)="isPricingMenuOpen = !isPricingMenuOpen">Pricing</button>
        <div class="admin-dropdown-menu" *ngIf="isPricingMenuOpen">
          <button class="admin-dropdown-item" (click)="navigateToScreen('AdminPricing'); isPricingMenuOpen = false">Tariff</button>
          <button class="admin-dropdown-item" (click)="navigateToScreen('AdminClientTier'); isPricingMenuOpen = false">Client Tier</button>
        </div>
      </div>
      }

      @if(isSystemAdministrator()) {
      <div class="admin-dropdown-wrapper">
        <div class="admin-dropdown-backdrop" *ngIf="isAdminMenuOpen" (click)="isAdminMenuOpen = false"></div>
        <button mat-flat-button class="flexMenuButton" extended (click)="isAdminMenuOpen = !isAdminMenuOpen">Admin</button>
        <div class="admin-dropdown-menu" *ngIf="isAdminMenuOpen">
          <button class="admin-dropdown-item" (click)="navigateToScreen('AdminUsers'); isAdminMenuOpen = false">Users</button>
          <button class="admin-dropdown-item" (click)="navigateToScreen('AdminClients'); isAdminMenuOpen = false">Clients</button>
          <button class="admin-dropdown-item" (click)="navigateToScreen('AdminBeneficiaries'); isAdminMenuOpen = false">Beneficiaries</button>
          <button class="admin-dropdown-item" (click)="navigateToScreen('AdminUtilities'); isAdminMenuOpen = false">Utilities</button>
          <button class="admin-dropdown-item" (click)="navigateToScreen('AdminTools'); isAdminMenuOpen = false">Tools</button>
          <!-- PAYG not ready for release yet - merged into master early, hidden from nav until launch -->
          <!-- <button class="admin-dropdown-item" (click)="navigateToScreen('AdminPayg'); isAdminMenuOpen = false">PAYG</button> -->

        </div>
      </div>
      }

      <div class="finance-dropdown-wrapper">
        <div class="admin-dropdown-backdrop" *ngIf="isHelpMenuOpen" (click)="isHelpMenuOpen = false"></div>
        <button mat-flat-button class="flexMenuButton" extended (click)="isHelpMenuOpen = !isHelpMenuOpen">Help</button>
        <div class="finance-dropdown-menu" *ngIf="isHelpMenuOpen">
          <button class="admin-dropdown-item" (click)="openAboutDialog(); isHelpMenuOpen = false">About</button>
        </div>
      </div>

      <div class="user-profile-container">
        <button mat-icon-button class="user-profile-button" [matMenuTriggerFor]="userMenu">
          <span class="user-avatar">{{getUserInitials()}}</span>
        </button>
        <mat-menu #userMenu="matMenu">
          <div class="user-menu-header">
            <span class="user-menu-name">{{loggedInUser?.firstName}} {{loggedInUser?.lastName}}</span>
            <span class="user-menu-email">{{loggedInUser?.email}}</span>
          </div>
          <mat-divider></mat-divider>
          <button mat-menu-item (click)="logout()">
            <mat-icon>logout</mat-icon>
            <span>Logout</span>
          </button>
        </mat-menu>
      </div>
    </div>

  </mat-toolbar-row>
  }
  @else if(!hasLoggedInUser)
  {
  <mat-toolbar-row class="matToolbarRow">
    <div class="flexMenu" [hidden]="hasLoggedInUser">
      <button mat-flat-button color="primary" class="flexMenuButton" extended>Nobody logged in</button>
    </div>
  </mat-toolbar-row>
  }

</mat-toolbar>

@if(!hasLoggedInUser && !isPaygPaymentRoute){
<app-login (loggedInUser)="userLoggedInOrOutStatusChange($event)"></app-login>
}
}

@if(isClientPortalRoute || isPaygPaymentRoute || hasLoggedInUser){
<div class="route-content">
  <router-outlet></router-outlet>
</div>
}
